export const maEditDateComponent = {
    bindings: {
        ngModel: '=',
        ngRequired: '=',
        help: '@',
        inputLabel: '@',
        inputAddon: '@',
    },
    require: {
        ngModelCtrl: "ngModel",
        form: '^form' // binds form to controller
    },
    template: ['$element', '$attrs', TemplateBuilder],
    controller: ['$element', AppEditCtrl],
    controllerAs: 'vm'
};
function AppEditCtrl($element) {
    const vm = this;
    this.$onInit = function () {
        vm.isRequired = function () {
            // Returns true if the input element editor has the 'required' attribute.
            // The attribute may be set by ng-required or required on the directive element.
            return !!($element.find('input').attr('required'));
        };
    };
}
function TemplateBuilder($element, $attrs) {
    // generate input id by ng-model and random number, removing all non-word characters (allows _ though)
    // regex \W is negation shorthand for \w
    const inputId = $attrs.inputId || ('fld' + $attrs.ngModel + Math.random()).replace(/\W+/g, '');
    const required = $attrs.required !== undefined ? 'required="true"' : '';
    const html = [];
    html.push(`<div class="form-group" ng-class="{ 'has-error' : vm.form.${inputId}.$invalid }">`);
    html.push(`<label for="${inputId}" translate>{{::vm.inputLabel}}</label>`);
    html.push(`<ma-datepicker id=${inputId} ng-model="vm.ngModel" ig-class="col-sm-3 col-md-2 col-sx-4" ${required}></ma-datepicker>`);
    html.push(`<div ng-messages="vm.form.${inputId}.$error" role="alert">`);
    html.push('<p ng-message="required" class="help-block bg-danger" translate>EDIT_PAKOLLINEN_TIETO</p>');
    html.push('<p ng-message="date" class="help-block bg-danger" translate>EDIT_VIRHEELLINEN_PVM</p>');
    html.push('</div>');
    if ($attrs.help) {
        html.push('<p class="help-block">{{::vm.help}}</p>');
    }
    html.push(`</div>`); // form-group
    return html.join("\n");
} // buildTemplate
